import React from "react"
import { Navigate } from "react-router-dom"

// Profile
import PatientProfile from "../pages/Authentication/user-profile"
import UserProfile from "../pages/Authentication/usersProfile"
// Pages Calendar
import Calendar from "../pages/Calendar/index"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"

// Inner Authentication
// import Login1 from "../pages/AuthenticationInner/Login"
// import Register1 from "../pages/AuthenticationInner/Register"
// import Recoverpw from "../pages/AuthenticationInner/Recoverpw"
import LockScreen from "../pages/AuthenticationInner/auth-lock-screen"

// Dashboard
import Dashboard from "../pages/Dashboard/index"

import User from "pages/User/DataTable"
import ServiceDuration from "pages/ServiceDuration/Datatable"
import Chat from "pages/Chat/DatatableTables"
import Leaves from "pages/Leaves/Datatable"

import UsersProfile from "../pages/Authentication/usersProfile"

import DurationServiceProfile from "pages/Authentication/durationServiceProfile"
import Service from "pages/Service/Datatable"
import ServiceProfile from "pages/Authentication/service-profile"
import DoctorTimeTableProfile from "pages/Authentication/doctor-timetable"

import Setting from "pages/Extra Pages/setting"

import DoctorAvailability from "pages/DoctorAvailability/Datatable"
import LeaveProfile from "pages/Authentication/leave-profile"
import TodaysAppointments from "pages/Todays Appointment/Datatable"
// import { components } from "react-select"
import ProtectedRoute from "components/ProtectedRoute/ProtectedRoute"
import AppointmentDetails from "pages/Authentication/TodaysAppointmentProfile"
import { components } from "react-select"
import Profile from "pages/Profile/UserProfile"
import { Route } from "react-router-dom"
import ChangePassword from "pages/ChangePassword/ChangePassword"

const userRoutes = [
  { path: "/dashboard", component: <Dashboard /> },

  // //calendar
  { path: "/calendar", component: <Calendar /> },

  { path: "/patient", component: <Chat /> },

  { path: "/user", component: <User /> },
  // { path: "/todays appointment", component: <TodaysAppointments /> },
  {
    path: "/todays-appointment",
    component: (
      <ProtectedRoute allowedRoles={["doctor", "admin","staff"]}>
        <TodaysAppointments />
      </ProtectedRoute>
    ),
  },
{path:"/profile",component:<Profile/>},
  // <Route path="/profile" element={<Profile />} />,
 

  { path: "/service-duration", component: <ServiceDuration /> },
  { path: "/service", component: <Service /> },
  { path: "/leave", component: <Leaves /> },
  { path: "/availability", component: <DoctorAvailability /> },
  {path:"/change-password",component:<ChangePassword/>},


  // // //profile
  { path: "/profile/:id", component: <PatientProfile /> },
  { path: "/user-profile/:id", component: <UsersProfile /> },
  { path: "/duration-profile/:id", component: <DurationServiceProfile />},
  { path: "/service-profile/:id", component: <ServiceProfile /> },
  { path: "/availability-profile/:id", component: <DoctorTimeTableProfile /> },
  { path: "/leave-profile/:id", component: <LeaveProfile /> },
  { path: "/appointment-details/:id", component: <AppointmentDetails/> },
  // {path:"/appointment-details/:id",component:</>}

  { path: "/setting", component: <Setting /> },

  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
]

const authRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/register", component: <Register /> },

  // Authentication Inner
  // { path: "/login", component: <Login1 /> },
  // { path: "/pages-register", component: <Register1 /> },
  // { path: "/page-recoverpw", component: <Recoverpw /> },
  { path: "/auth-lock-screen", component: <LockScreen /> },
]

export { userRoutes, authRoutes }
